import { atom } from "@byko/lib-recoil";

import type { ModalProps } from "@byko/types-modal";

export const modalPropsState = atom<ModalProps | undefined>({
  key: "modal-props",
  default: undefined,
});
